import { Component, OnInit, Input, ViewChild, Output, EventEmitter, Inject } from '@angular/core';
import { AppService } from '../../app.service';
import { AuthService } from '../../core/auth.service';
import { BaseService } from '../../shared/base.service';
import { Router } from '@angular/router';
import { BaseComponent } from '../../shared/base.component';
import { QuestionnairesService } from '../questionnaires/questionnaires.service';
import { PatientService } from '../patient.service';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { UsersService } from '../../users/users.service';
import { ProposalDiagnosisService } from '../proposal-diagnosis/proposal-diagnosis.service';

@Component({
    selector: 'app-patient-selected-diagnoses',
    templateUrl: './patient-selected-diagnoses.component.html',
    styleUrls: ['./patient-selected-diagnoses.component.scss']
})
export class PatientSelectedDiagnosesComponent extends BaseComponent implements OnInit {

    constructor(
        public appService: AppService,
        public authService: AuthService,
        public baseService: BaseService,
        public questionnairesService: QuestionnairesService,
        public proposalDiagnosisService: ProposalDiagnosisService,
        public patientService: PatientService,
        public translate: TranslateService,
        public usersService : UsersService,
        @Inject('reviewProposalStatisticKey') public reviewProposalStatisticKey,
        public router: Router) {
            super(authService, router, baseService, appService);
    }

    @Input() items: Object[] = [];
    @Input() patientId : number;
    @Input() lastestQuestionnaire : Object;
    @Input() viewOnly : false;

    @Output() openProposalDiagnosis = new EventEmitter();
    patientSub: Subscription;
    dataSub: Subscription;
    proposals: Object[] = [];
    selectedDiagnoses: Object[];
    ld = _;
    isCriteriaExpanded: Object[] = [];
    loadedData = false;

    readonly patientDiagnosisTableColumns = [
        ['code', 'ICD Code', 'col-xs-1 icd-code', 'text'],
        ['name', 'Diagnosis', 'col-xs-3 diagnosis-name', 'text'],
        ['related_domain', 'Domains', 'col-xs-2 col-domain', 'text'],
        ['percentage', 'System Match', 'col-xs-1 col-probability', 'text'],
        ['created_at', 'Date', 'col-xs-2 col-date', 'text'],
        ['creator', 'Doctor', 'col-xs-3 col-creator', 'text'],
    ];
    readonly diagnosisColumns = ['name'];

    ngOnInit() {
        if (this.lastestQuestionnaire) {
            this.appService.isLoading = true;
            this.patientSub = this.proposalDiagnosisService.getSelectedDiagnosis(this.lastestQuestionnaire['id']).subscribe((rs) => {
                this.patientService.proposalData = rs['proposal'];
                this.appService.isLoading = false;
                return this.initProposal();
            });
        } else {
            this.loadedData = true;
        }

        this.dataSub = this.appService.subscribe('patient', data => {
            if (data['selectedDiagnosesAreUpdated']) {
                this.appService.publish('patient', {selectedDiagnosesAreUpdated: false});
                return this.initProposal();
            }
        });

    }

    ngOnDestroy() {
        if (this.patientSub) {
            this.patientSub.unsubscribe();
        }
        if (this.dataSub) {
            this.dataSub.unsubscribe();
        }
    }

    initProposal(){
        this.generateProposalData();
        // Check diagnosis of patient
        if (this.patientService.selectedDiagnoses && this.patientService.selectedDiagnoses.length > 0) {
            this.patientService.selectedDiagnoses.forEach(diagnosis => {
                const index = this.proposals.findIndex(item => item['diagnoses']['id'] === diagnosis['id']);
                if (index < 0) {
                    // Create proposal data
                    let proposal = {
                        diagnoses : diagnosis,
                        diagnoses_id: diagnosis['id'],
                        criterias : diagnosis['criterias'] ? diagnosis['criterias'] : [],
                        percentage : {
                            from: 0,
                            to: 0
                        },
                        related_domain : diagnosis['related_domain'] ? diagnosis['related_domain'] : []
                    };
                    this.proposals.push(proposal);
                }
            });
        }

        // Order diagnosis
        this.proposals.sort((first, second) => {
            return first['diagnoses']['pivot']['order'] - second['diagnoses']['pivot']['order'];
        });
        // Format data of selected diagnosis
        this.patientService.generateSelectedDiagnoses();
        this.loadedData = true;
    }

    generateProposalData(){
        this.proposals = [];
        let selectedIds = [];
        let formattedDiagnosis = [];
        this.patientService.selectedDiagnoses.forEach(item => {
            selectedIds.push(item['id']);
            formattedDiagnosis[item['id']] = item;
        });
        if (this.patientService.proposalData) {
            // Deep clone data of proposal
            let proposalData =  _.cloneDeep(this.patientService.proposalData);
            proposalData.forEach(proposal => {
                if (selectedIds.indexOf(proposal['diagnoses_id']) >= 0) {
                    if(!proposal.criterias){
                        proposal.criterias = [];
                        proposal.percentage = {
                            from: 0,
                            to: 0
                        }
                    }
                    // Replace diagnosis of proposal by formatted diagnosis
                    proposal.diagnoses = formattedDiagnosis[proposal['diagnoses_id']];
                    this.proposals.push(proposal);
                }
            });
        }
    }

    edit(proposal = null){
         // save statistics for current user
         this.usersService.saveStatistics(this.reviewProposalStatisticKey)
         .subscribe(data => {
         });

        this.openProposalDiagnosis.emit(proposal);
    }

    confirmToDelete(item) {
        const dialog = this.dialog.openConfirm({
            content: 'Do you really want to remove this diagnose?',
            icon: 'fas fa-exclamation-triangle',
            cancelText: 'No',
            submitText: 'Yes'
        });

        dialog.onSubmit(() => {
            this.patientService.patientId = this.patientId;
            this.patientService.deleteDiagnosis(item.diagnoses);
            dialog.hideModal();
        });
    }

    confirmAction(params: Object) {
        this.initForm(params);
        this.showModal();
    }

    toggleCollapse(proposal){
        if(!proposal.criterias){
            return false;
        }
        this.isCriteriaExpanded[proposal.diagnoses_id] = !this.isCriteriaExpanded[proposal.diagnoses_id];
    }
}
